import { compose } from 'recompose';
import { omit } from 'lodash';
import { set as setFp, omit as omitFp } from 'lodash/fp';
import { BLOCK_MODEL_STYLING_KEYS } from '../const/StylingOverlapBlockModelKeys';
import {
  DRAFT_INLINE_STYLE_FONT_STYLE_ITALIC,
  DRAFT_INLINE_STYLE_FONT_WEIGHT_BOLD,
  DRAFT_INLINE_STYLE_TEXT_TRANSFORM_UNDERLINE,
} from '../../richText/const/draftInlineStyle';

const BLOCK_DATA_STYLES = [
  'color',
  'font',
  'fontSize',
  DRAFT_INLINE_STYLE_FONT_WEIGHT_BOLD,
  DRAFT_INLINE_STYLE_FONT_STYLE_ITALIC,
  DRAFT_INLINE_STYLE_TEXT_TRANSFORM_UNDERLINE,
];

const unsetContentCustomStyles = content => {
  if (!content) {
    return;
  }
  return {
    ...content,
    blocks: content.blocks.map(
      compose(
        omitFp(BLOCK_DATA_STYLES.map(dataKey => `data.${dataKey}`)),
        setFp('inlineStyleRanges', []),
      ),
    ),
  };
};

export const unsetRichTextBlockStyles = block =>
  block.content
    ? {
        ...block,
        content: unsetContentCustomStyles(block.content),
      }
    : block;

export const unsetOptionsRichTextStyles = block =>
  block.options
    ? {
        ...block,
        options:
          block.options &&
          block.options.map(option => ({
            ...option,
            content: unsetContentCustomStyles(option.content),
          })),
      }
    : block;

const unsetBlockStyles = block => omit(block, BLOCK_MODEL_STYLING_KEYS);

export const unsetBlockInlineStyles = block => {
  return compose(
    unsetBlockStyles,
    unsetRichTextBlockStyles,
    unsetOptionsRichTextStyles,
  )(block);
};
